export function removeDeletedDateFromSerialNo(serialNo: string) {
    const deletedIndex = serialNo.indexOf('?deleted_date=');
    if (deletedIndex === -1) {
        return serialNo;
    }

    return serialNo.substring(0, deletedIndex);

}
